import { assetTypeMap } from "../../leases/components/LeaseConstants";

export const getDeliveryConditionApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/delivery${queryString ? `?${queryString}` : ""}`;
};

export const editDeliveryConditionApi = (params) => {
    return `/lease/${params?.leaseSlug}/delivery`;
}

export const  addAssemblysApi=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies?delivery_assembly_type=delivery`
}

export const  updateAssemblysApi=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}?delivery_assembly_type=delivery`
}

export const  getAssemblysList=(params)=>{
    return `lease/${params?.leaseSlug}/delivery-assemblies?delivery_assembly_type=delivery`
}

export const  getMaintenanceListAPI=(params)=>{
    return `config/maintenance-checks/${assetTypeMap[params?.asset?.asset_type]}/${params?.asset?.id}/`
}

export const  addAssemblysEventApi=(params)=>{
    const leaseSlug = params?.leaseSlug || params?.params?.leaseSlug;
    return `/lease/${leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events`
}

export const  updateAssemblysEventApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events/${params?.event_slug}`
}

export const  deleteAssemblysEventApi=(params)=>{
    return `/lease/${params?.params?.leaseSlug}/delivery-assemblies/${params?.assembly_slug}/maintenance_events`
}

export const getClauseAPi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/condition_clause${queryString ? `?${queryString}` : ""}`;
};
